module.exports = __webpack_public_path__ + "static/media/cargo-ship.9097a33e.svg";